import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm, Controller } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import validation from "./validation";
import {
  Table,
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
  Tabs,
  Tab,
} from "react-bootstrap";
import services from "../../API/services";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from 'moment-timezone';
import { useMemo } from "react";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { Margin, Resolution, usePDF } from "react-to-pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useRef } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { InputField } from "../../components/InputField/InputField";
import { createLogs, createKotLogs } from "../../store/slices/PropertyData";
import {
  KOT_TYPE,
  USER_DEG_TEXT,
  renderTags,
  statusfoodColor,
} from "constant/constants";
import ReactGA from "react-ga4";
import { showPrice, showRowPrice } from "utils/utils";
import {
  getPropertyUsersAction,
  usersSeletor,
} from "../../store/slices/userSlice";
import PaymentModal from "./PaymentModal";
import api from "API/client/api";
import FoodInvoiceBill from "pages/foodinvoice/FoodInvoice";

import { FaReceipt, FaTrash } from "react-icons/fa";

export const ORDER_STATUS = {
  NEW_ORDER: 0,
  IN_KITCHEN: 1,
  READY: 2,
  DELIVERED: 3,
  CANCELED: 4,
  NCKOT: 5,
  ALL: 6,
};

export const statusfood = [
  "New Order",
  "Accepted By Kitchen",
  "Food is Ready",
  "Delivered",
  "Cancelled",
];

const FoodsOrders = () => {
  const changeStatus = async ({ id, bookingId }, status) => {
    // ["KOT", "In-process", "Delivered ", "Complete", "Canceled"];
    setIsLoading(true);
    const orderMessages = [
      "Food Order Accepted Successfull !",
      "Food Order Ready !",
      "Food Order Delivered Successfull !",
      "Food Order Rejected Successfull !",
    ];
    try {
      if (!window.confirm("Are You Sure Want to Change Status")) {
        setIsLoading(false);
        return;
      }
      const realPayload = {
        order_status: statusfood.indexOf(status) + 1,
      };
      if (status == "New Order") {
        realPayload.acceptedBy = userDetail?.id
      }
      if (status == "Food is Ready") {
        realPayload.deliveredBy = userDetail?.id
      }
      if (status == "Delivered") {
        realPayload.rejectedBy = userDetail?.id
      }
      const res = await services.property.updateFoodOrderStatus(
        realPayload,
        id
      );
      if (res.status == 200) {
        getDataHandler();
        toast.success(orderMessages[statusfood.indexOf(status)], {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        let xName = (status == "New Order" && "accepted") || (status == "Accepted By Kitchen" && "Marked Ready") || (status == "Food is Ready" && "Delivered") || (status == "Delivered" && "Rejected")
        const params = {
          action: status == "Food is Ready" ? `${xName} Food Order` : `KOT ${xName}`,
          actionBy: userDetail?.name,
          operation: status == "Food is Ready" ? `${xName} Food Order` : `KOT ${xName}`,
          propertyId: userDetail?.propertyId,
          bookingCode: id
        }
        dispatch(createKotLogs(params));
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const tableRef = useRef();
  const { userDetail } = useSelector(authenticationSeletor);
  const { propertyUsers } = useSelector(usersSeletor);
  const [activeTab, setActiveTab] = useState(ORDER_STATUS.NEW_ORDER);
  const [itemsModal, setItemsModal] = useState(false);
  const { AlertIcon } = Imagesdata || {};
  const [show, setShow] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [selectItemsShow, setSelectItemsShow] = useState([]);
  const [roomNumbers, setRoomNumbers] = useState([]);
  const [bookingData, setBookingData] = useState([]);
  const [foodItems, setFoodItems] = useState([]);
  const [orderAmt, setOrderAmt] = useState(0);
  const [filterOrders, setFilterOrders] = useState([]);
  const [BookingId, setBookingId] = useState({});
  const [loginUsers, setLoginUsers] = useState([]);
  const [ncType, setNcType] = useState(false);
  const [ncTypeError, setNcTypeError] = useState(false);
  const [ncPriceData, setNcPriceData] = useState({});
  const [roomErrorShow, setRoomErrorShow] = useState(false);
  const [filterDate, setFilterDate] = useState(new Date());
  const [waiterList, setWaiterList] = useState([])
  const [paymentModal, setPaymentModal] = useState(false);
  const [singleOrders, setSingleOrders] = useState({})
  const [itemInput, setItemInput] = useState([
    { itemName: "", qty: 1, price: "", amount: "", totalAmountBeforeGst: "" },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [amountBeforeGst, setAmountBeforeGst] = useState(0);
  const [propertyData, setPropertyData] = useState({});
  const [editableKot, setEditableKot] = useState({})
  const [kotSelectedRoom, setKotSelectedRoom] = useState()

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const { kotType, selectRoom, waiterName, remarks } = watch()

  const renderTag = [
    { id: 0, name: "Room Service" },
    { id: 1, name: "Dine-In" },
    { id: 2, name: "TakeAway" },
    { id: 3, name: "Staff" },
    { id: 4, name: "NC" },
    { id: 5, name: "Complementary" },
  ];

  const getPropertyDetail = async () => {
    try {
      const res = await services.property.getSinglePropertyService(
        userDetail?.propertyId,
        true
      );
      if (res.status === 200) {
        setPropertyData(res?.data?.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getPropertyDetail();
  }, []);

  useEffect(() => {
    dispatch(getPropertyUsersAction(userDetail.propertyId));
  }, [userDetail]);

  useEffect(() => {
    let getUsers = [];
    propertyUsers.map((data) => {
      if (userDetail?.propertyId == data.propertyId) {
        getUsers.push(data);
      }
    });
    setWaiterList(
      userDetail?.logintype == "rroomUser" ? propertyUsers : getUsers
    );
  }, [propertyUsers, userDetail]);

  const { roomNo } = watch();
  useEffect(() => {
    if (ncType) {
      setRoomErrorShow(false);
    } else if (!ncType && roomNo != "") {
      setRoomErrorShow(false);
    } else {
      setRoomErrorShow(true);
    }
    if (roomNo == "") {
      setBookingId({});
    }
  }, [ncType, roomNo]);

  useEffect(() => {
    if (kotType != "Room Service" || kotType != "Complementary") {
      setValue("selectRoom", "")
    }
  }, [kotType])

  const onSubmit = async (payload) => {
    if (ncType == '') {
      setNcTypeError(true)
    }
    if (roomErrorShow) {
      setRoomErrorShow(true);
      return;
    }
    setSubmitDisabled(true);
    let goBack;
    itemInput.forEach((e) => {
      if (
        e.qty.length <= 0 ||
        !e.qty ||
        !e.itemName ||
        e.itemName.length <= 0
      ) {
        goBack = true;
        return;
      }
    });
    if (goBack) {
      setSubmitDisabled(false);
      return;
    }
    let items = [];
    itemInput?.map((item) => {
      const tempPrice = item?.itemName?.finalPrice || item?.itemName?.price;
      items.push({
        id: Number(item?.itemName?.value),
        qty: Number(item.qty),
        name: item?.itemName?.name,
        price: tempPrice,
        amountBeforeTax: item?.itemName?.amountBeforeTax,
        taxAmount: item?.itemName?.taxAmount * Number(item.qty),
        propertyId: item?.itemName?.propertyId,
        gstPercentage: item?.itemName?.gstPercent,
        totalAmount: tempPrice * Number(item.qty),
      });
    });
    const realPayload = {
      user_id: 0,
      booking_id: (kotType == "Room Service" || kotType == "Complementary") ? BookingId?.id : 0,
      room_number: payload.selectRoom,
      order_amount: kotType == "Complementary" || kotType == "NC" ? 0 : Number(orderAmt),
      order_items: items,
      created_by: userDetail?.id,
      nc_type: kotType ? kotType : "0",
      otherGuestName: (kotType == "Room Service" || kotType == "Complementary") ? payload.otherName ?? BookingId?.otherPersonName ?? BookingId?.User?.name : "",
      remark: payload.remarks,
      waiterID: payload.waiterName,
      propertyId: userDetail?.propertyId,
      totalFoodAmountBeforeGST: kotType == "Complementary" ? 0 : amountBeforeGst,
      isKitchen: true
    };
    if (editMode) {
      realPayload.dueAmount = orderAmt
    }
    try {
      let res = {};
      let msg = "";
      if (editMode) {
        res = await services.property.updateFoodOrders(
          realPayload,
          selectedData.id
        );
        msg = "Updated";
      } else {
        res = await services.property.createFoodOrders(realPayload);
        msg = "Placed";
      }
      if (res.status === 200) {
        setSubmitDisabled(false);
        reset();
        setNcType(false);
        setShow(false);
        setEditMode(false);
        getDataHandler();
        setBookingId({});
        setItemInput([{ itemName: "", qty: 1, price: "", amount: "" }]);
        toast.success(`Food Order Successfully ${msg}*`, {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        let roomKot = kotType == "Room Service" ? `( ${kotSelectedRoom} )` : ''
        const params = {
          action: `KOT ${editMode ? 'Modified' : 'created'}`,
          actionBy: userDetail?.name,
          operation: `${editMode ? 'Modified' : 'Created'}, 
          KOT Type - (${kotType} ${roomKot}), 
          Order Items - (${items?.map((data) => { return ` ${data.name}` })} ), 
          Waiter Name - (${waiterList.find((w) => w.id == payload.waiterName)?.firstName}),
          Amount - (₹${orderAmt})`,
          propertyId: userDetail?.propertyId,
          bookingCode: editMode ? editableKot.id : res?.data?.data?.id
        }
        dispatch(createKotLogs(params));
      }
    } catch (error) {
      setSubmitDisabled(false);
    }
  };

  const getNcPrice = async () => {
    try {
      const res = await services.property.getNcTypeByProperty(
        userDetail?.propertyId
      );
      if (res.status === 200) {
        setNcPriceData(res.data.data[0]);
      }
    } catch (error) { }
  };

  const getRecentBooking = async () => {
    try {
      const res = await services.globalService.getBookingPropertyIdService(
        userDetail?.propertyId,
        `?page=1&limit=100&bookingStatus=2`
      );
      const foodResponse = await services.property.getFoodItemsProperty(
        `?property_id=${userDetail?.propertyId}`
      );
      if (res?.status === 200) {
        setRoomNumbers(res?.data?.data)
        setBookingData(res?.data?.data);
        let itemsArr = [];
        foodResponse.data?.data?.map((item) => {
          let obj = {
            value: item?.id,
            label: item?.name,
            price: item?.finalPrice,
            ...item,
          };
          itemsArr.push(obj);
        });
        setFoodItems(itemsArr);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (selectRoom) {
      const bookData = bookingData?.find((item) =>
        item?.assignRoomNo.includes(selectRoom)
      );
      setBookingId(bookData);
    }
  }, [selectRoom]);

  useEffect(() => {
    let totalAmount = 0;
    itemInput?.map((item) => {
      totalAmount += item.amount;
    });
    if (ncType) {
      setOrderAmt(
        Math.round(totalAmount - (totalAmount * ncPriceData?.ncType) / 100)
      );
    } else {
      setOrderAmt(totalAmount);
    }
  }, [itemInput, ncType]);

  useEffect(() => {
    let totalAmountBeforeGst = 0;
    itemInput.map((item) => {
      totalAmountBeforeGst += item.totalAmountBeforeGst || Math.round(item.itemName.amountBeforeTax);
    });
    setAmountBeforeGst(totalAmountBeforeGst);
  }, [itemInput, ncType]);

  const editHandler = (data) => {
    setEditableKot(data)
    setAmountBeforeGst(data?.totalFoodAmountBeforeGST);
    setSelectedData(data);
    setShow(true);
    setKotSelectedRoom(`${data?.roomNumber} - ${data?.BookingHotel?.bookingCode}`)
    setValue("kotType", data?.ncType);
    setValue("selectRoom", data?.roomNumber || data?.selectRoom);
    setValue("waiterName", data?.waiterID)
    setValue("remarks", data?.remark)
    let parsedItems = [];
    parsedItems = JSON.parse(data?.orderItems || "[]");
    const editItemsData = parsedItems.map((item) => {
      const matchedFood = foodItems?.find((i) => i.value === item.id);
      return {
        itemName: {
          value: item?.id,
          label: matchedFood?.label || item?.name,
          price: matchedFood?.price || item?.price,
          itemCode: matchedFood?.itemCode,
          ...item,
        },
        qty: item?.qty,
        price: item?.price,
        amount: item?.price * item?.qty,
      };
    });
    const bookData = bookingData?.find((item) =>
      item?.assignRoomNo.includes(data?.roomNumber)
    );
    setBookingId(bookData);
    setItemInput(editItemsData);
    setEditMode(true);
  };

  const getDataHandler = async () => {
    try {
      const res = await services.property.getFoodOrdersByProperty(
        userDetail?.propertyId
      );
      if (res.status === 200) {
        setTableData(res.data.data);
      }
    } catch (error) { }
  };

  const getDataHandlers = async () => {
    try {
      const res = await services.property.getFoodOrdersByProperty(
        userDetail?.propertyId
      );
      if (res?.status === 200) {
        setTableData(res?.data?.data);
        let newData = res?.data?.data.find((item) => item.id == singleOrders.id) || {}
        setSingleOrders(newData)
      }
    } catch (error) { }
  };

  useEffect(() => {
    getDataHandlers()
  }, [setSingleOrders])

  useEffect(() => {
    getDataHandler();
    getRecentBooking();
    getNcPrice();
  }, [userDetail]);

  const foodOrderData = useMemo(() => {
    return tableData?.reduce((acc, booking) => {
      const { orderStatus, paymentStatus, ncType } = booking || {};
      // NC KOT (always push)
      if (ncType == "1") {
        acc[ORDER_STATUS.NCKOT].push(booking);
      }
      // New Order
      if (orderStatus === ORDER_STATUS.NEW_ORDER) {
        acc[ORDER_STATUS.NEW_ORDER].push(booking);
      }
      // In Kitchen
      else if (orderStatus === ORDER_STATUS.IN_KITCHEN) {
        acc[ORDER_STATUS.IN_KITCHEN].push(booking);
      }
      // Ready
      else if (orderStatus === ORDER_STATUS.READY) {
        acc[ORDER_STATUS.READY].push(booking);
      }
      // Delivered
      else if (orderStatus === ORDER_STATUS.DELIVERED) {
        acc[ORDER_STATUS.DELIVERED].push(booking);
        if (ncType == "NC") {
          acc[ORDER_STATUS.NCKOT].push(booking);
        }
      }
      // Cancelled
      else if (orderStatus === ORDER_STATUS.CANCELED) {
        acc[ORDER_STATUS.CANCELED].push(booking);
      }
      return acc;
    }, {
      [ORDER_STATUS.NEW_ORDER]: [],
      [ORDER_STATUS.IN_KITCHEN]: [],
      [ORDER_STATUS.READY]: [],
      [ORDER_STATUS.DELIVERED]: [],
      [ORDER_STATUS.CANCELED]: [],
      [ORDER_STATUS.NCKOT]: [],
      [ORDER_STATUS.ALL]: tableData || [],
    });
  }, [tableData]);

  const propertyStatusTabs = useMemo(
    () => [
      {
        key: ORDER_STATUS.NEW_ORDER,
        title: `New Order (${foodOrderData[ORDER_STATUS.NEW_ORDER]?.length})`,
      },
      {
        key: ORDER_STATUS.IN_KITCHEN,
        title: `In-Kitchen (${foodOrderData[ORDER_STATUS.IN_KITCHEN]?.length})`,
      },
      {
        key: ORDER_STATUS.READY,
        title: `Ready to Serve (${foodOrderData[ORDER_STATUS.READY]?.length})`,
      },
      {
        key: ORDER_STATUS.DELIVERED,
        title: `Delivered (${foodOrderData[ORDER_STATUS.DELIVERED]?.length})`,
      },
      {
        key: ORDER_STATUS.CANCELED,
        title: `Rejected (${foodOrderData[ORDER_STATUS.CANCELED]?.length})`,
      },
      {
        key: ORDER_STATUS.NCKOT,
        title: `NC KOT (${foodOrderData[ORDER_STATUS.NCKOT]?.length})`,
      },
      {
        key: ORDER_STATUS.ALL,
        title: `All (${tableData?.length})`,
      },
    ],
    [foodOrderData]
  );

  const changeHandler = (e, index, isSearch = false) => {
    let tempData = [...itemInput];
    if (isSearch) {
      tempData[index].itemName = e;
      tempData[index].price = e?.finalPrice?.toString();
      tempData[index].amount = tempData[index].qty * tempData[index].price;
      // ✅ Correct way to set amount before tax
      tempData[index].amountBeforeTax = e?.amountBeforeTax; // store per unit before tax price
      tempData[index].totalAmountBeforeGst = tempData[index].qty * e?.amountBeforeTax;
    } else {
      tempData[index][e.target.name] = e.target.value;
      tempData[index].amount = tempData[index].qty * tempData[index].price;
      // ✅ Also update totalAmountBeforeGst when qty or price changes
      tempData[index].totalAmountBeforeGst = tempData[index].qty * tempData[index].amountBeforeTax;
    }
    setItemInput(tempData);
  };

  const getAllUser = async () => {
    try {
      const res = await services.property.getInventoryEmplyoee();
      if (res.status === 200) {
        setLoginUsers(res.data.result);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getAllUser();
  }, []);

  const closeHandler = (index) => {
    let tempData = [...itemInput];
    tempData.splice(index, 1);
    setItemInput(tempData);
  };

  const [selectedPrinter, setSelectedPrinter] = useState(null);
  const printers = ["A4", "Thermal"];

  const getPageFormat = () => {
    return selectedPrinter === "A4" ? "A6" : [80, 160];
  };

  const { toPDF: kotPdf, targetRef: kotPrint } = usePDF({
    method: "open",
    filename: "kot.pdf",
    page: {
      margin: Margin.NONE,
      format: getPageFormat(),
      unit: "mm",
    },
    resolution: 4,
    canvas: { mimeType: "image/png", qualityRatio: 1 },
  });

  const printKot = () => {
    if (!selectedPrinter) {
      alert("Please select a printer first!");
      return;
    }
    kotPdf().then(() => {
      const params = {
        bookingId: selectItemsShow?.bookingId,
        action: `Food KOT Print on ${selectedPrinter}`,
        actionBy: `${userDetail?.firstName} ${userDetail?.lastName}`,
        userType: "propertyUser",
      };
      dispatch(createLogs(params));
      setSelectedPrinter('')
    });
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "FoodOrders",
    sheet: "FoodOrders",
  });

  const dateFilter = () => {
    const resultsData = foodOrderData[activeTab].filter((order) => {
      return (
        moment(order?.createdAt).format("DD-MM-YYYY") ==
        moment(filterDate).format("DD-MM-YYYY")
      );
    });

    setFilterOrders(resultsData);
  };

  useEffect(() => {
    dateFilter();
  }, [filterDate]);

  const searchfilter = (text) => {
    const results = foodOrderData[activeTab].filter((order) => {
      if (text === "") return foodOrderData[activeTab];
      return (
        order.bookingId +
        order.BookingHotel?.bookingCode +
        order.roomNumber +
        order.id +
        Math.round(order.orderAmount + order.orderAmount * 0.05) +
        KOT_TYPE?.find((i) => i.id == order.ncType)?.name +
        loginUsers.find((i) => i.id == order.createdBy)?.firstName +
        order.otherGuestName
      )
        .toString()
        ?.toLowerCase()
        ?.includes(text?.toLowerCase());
    });
    setFilterOrders(results);
  };

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "kitchen_orders" });
    setFilterOrders(foodOrderData[activeTab]);
  }, [activeTab, tableData]);

  const quatitySetup = (item, state, index) => {
    const { price, amountBeforeTax } = item;
    let tempQty = itemInput.find((item, i) => i === index)?.qty;
    let tempData = [...itemInput];
    let k = 0;
    if (state) {
      k = tempQty + 1;
    } else {
      if (tempQty > 1) {
        k = tempQty - 1;
      } else {
        k = tempQty;
      }
    }
    tempData[index].qty = k;
    tempData[index].amount = k * price;
    tempData[index].totalAmountBeforeGst = k * amountBeforeTax;
    setItemInput(tempData);
  };

  const parsedData = selectItemsShow?.orderItems
    ? JSON.parse(selectItemsShow?.orderItems)
    : [];

  const [selectedKot, setSelectedKot] = useState({})

  const handlePayments = (data) => {
    setPaymentModal(true)
    setSingleOrders(data)
    getDataHandler()
  }

  const [foodPaymentHistory, setFoodPaymentHistory] = useState([]);
  // Food Payment History for print
  const fetchFoodPaymentHistory = async () => {
    try {
      let res = await api.get(`/rrooms-property/food-order-payment?order_id=${selectedKot?.id}`, {
        hideLoader: true,
      })
      if (res?.data?.status == true) {
        setFoodPaymentHistory(res?.data?.data.result)
      }
    }
    catch { }
  }

  useEffect(() => {
    if (selectedKot?.id) {
      fetchFoodPaymentHistory();
    }
  }, [selectedKot]);

  const [contentHeightMM, setContentHeightMM] = useState(60); // default

  const { toPDF: toPDF21, targetRef: paymentSlip } = usePDF({
    method: "open",
    filename: "payment-recept.pdf",
    page: {
      margin: Margin.NONE,
      format: [80, 160],
      unit: "mm",
    },
    resolution: 4,
    canvas: { mimeType: "image/png", qualityRatio: 1 },
  });

  const printPaymentSlip = (data) => {
    setSelectedKot(data);
    setTimeout(() => {
      toPDF21();
    }, 500);
  };

  useEffect(() => {
    if (paymentSlip.current) {
      const heightPx = paymentSlip.current.offsetHeight;
      const heightMM = heightPx / 3.7795;
      setContentHeightMM(heightMM + 10);
    }
  }, [selectedKot]);

  const [selectedInvoiceData, setSelectedInvoiceData] = useState({})
  const { toPDF: toPDF2, targetRef: foodInvoice } = usePDF({
    method: "open",
    filename: "food-order-invoice.pdf",
    page: {
      margin: Margin.SMALL,
      format: "A4"
    },
    resolution: 2,
    canvas: { mimeType: "image/png", qualityRatio: 0.7 },
  });

  const printInvoice = async (data) => {
    setSelectedInvoiceData(data);
    setTimeout(() => {
      toPDF2();
    }, 100);
  }

  let invoiceOrderItems = [];
  try {
    if (selectedInvoiceData?.orderItems) {
      invoiceOrderItems = JSON.parse(selectedInvoiceData.orderItems);
    }
  } catch (error) {
    invoiceOrderItems = [];
  }

  let discountNewAmount = (selectedInvoiceData.totalFoodAmountBeforeGST) - (selectedInvoiceData?.totalFoodAmountBeforeGST * selectedInvoiceData?.discountPercentage / 100)
  let newAmount = discountNewAmount + (discountNewAmount * 5 / 100)

  const today = new Date()

  function formatToIST(utcDateString) {
    const date = new Date(utcDateString);
    return date.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  }

  const [showPaymentPopup, setShowPaymentPopup] = useState(false)

  const deleteFoodPayment = async (id) => {
    const isConfirm = window.confirm("Are you sure you want to delete this payment?");
    if (!isConfirm) return;
    try {
      const res = await services.property.deleteFoodPaymentService({
        foodPaymentId: id
      });
      if (res?.data?.status) {
        fetchFoodPaymentHistory();
        getDataHandler()
        toast.success(res?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };



  return (
    <Layout
      title="Food Orders"
      buttonTitle="Place Order"
      openHandler={() => setShow(true)}
      extraBtnHandler={onDownload}
      extraButton="Export in Excel"
      searchfilter={searchfilter}
      setFilterDate={setFilterDate}
      filterDate={filterDate}
      dateFilterText="Select Date:"
    >
      <div className="printBox print-font" ref={paymentSlip} style={{ width: '80mm', position: "fixed", bottom: '0px', right: '40px', zIndex: "-999", padding: '20px' }}>
        <Table className="print-table">
          <thead>
            <tr>
              <th colSpan={2}>
                <p style={{ textAlign: 'center', fontSize: '10px', padding: '0px', paddingBottom: '0px' }}>GSTIN No.: {propertyData?.gstNumber}</p>
                <h1>{propertyData?.name}</h1>
                <h5 className="fs-8">{propertyData?.address}</h5>
                <p className="m-0"><span>Contact No -</span>{propertyData?.ownerMobile}</p>
                <p className="m-0"><span>{selectedKot?.ncType} </span></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-bottom border-dark">
              <td className="head pb-2">{selectedKot?.bookingId == 0 ? 'Order Id' : 'Booking Id '} - </td>
              <td className="head pb-2 text-right fw-bold">
                {selectedKot?.bookingId == 0 ? selectedKot?.id : selectedKot?.bookingCode}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <div style={{ height: '5px' }}></div>
              </td>
            </tr>
            {
              foodPaymentHistory?.map((history, i) => {
                return (
                  <tr key={i + 1} className="border-bottom border-dashed">
                    <td>
                      {
                        (history?.paymentMode == "2" && "CASH") ||
                        (history?.paymentMode == "3" && "CARD") ||
                        (history?.paymentMode == "5" && "UPI")
                      }
                    </td>
                    <td className="text-right fw-bold">{showPrice(history?.paymentAmount)}</td>
                  </tr>
                )
              })
            }
            <tr>
              <td colSpan={2}>
                <div style={{ height: '5px' }}></div>
              </td>
            </tr>
            <tr>
              <td>Total Amount</td>
              <td className="text-right fw-bold">{showPrice(selectedKot?.orderAmount)}</td>
            </tr>
            <tr>
              <td>Paid Amount</td>
              <td className="text-right fw-bold">{showPrice(selectedKot?.paidAmount ? selectedKot?.paidAmount : 0)}</td>
            </tr>
            <tr>
              <td>Discount Amount</td>
              <td className="text-right fw-bold">{showPrice((selectedKot?.totalFoodAmountBeforeGST * selectedKot?.discountPercentage) / 100)}</td>
            </tr>
            <tr>
              <td>Due Amount</td>
              <td className="text-right fw-bold">{showPrice(selectedKot?.dueAmount)}</td>
            </tr>
            <tr>
              <td colSpan={2}>
                <div className="text-center mt-2" style={{ height: '50px' }}>
                  <p className="d-block fs-6 m-0">This is not a tax invoice.</p>
                  <p className="d-block fs-6 m-0">Have a nice day!</p>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="printBox print-font-lg" ref={foodInvoice} style={{ width: '100%', position: "fixed", bottom: '0px', right: '0px', zIndex: "-999", }}>
        <div className="foodInvoice ">
          <div className=" bg-white py-2 foodPdf">
            <span className="text-black gstText text-center d-block" style={{ fontSize: "16px" }}>
              GSTIN No.: {propertyData?.gstNumber}
            </span>
            <div className="text-center text-black content">
              <h1>{propertyData?.name}</h1>
              <span style={{ fontSize: '16px' }}>{propertyData?.address}</span>
              <span style={{ fontSize: '16px' }}>Contact No.:{propertyData?.ownerMobile}</span>
              <span style={{ fontSize: '16px' }}>
                {selectedInvoiceData?.ncType}
              </span>
            </div>

            <div style={{ padding: '5px' }} className={'page-break'}>
              <div className="borderedDiv" style={{ borderTop: 'none' }}>
                <p>
                  Bill Number: <span>
                    {selectedInvoiceData.id}
                  </span>
                </p>
                <p>
                  Date: <span>
                    {moment(today).format('DD-MM-YYYY')}
                  </span>
                </p>
              </div>
              <div className="borderedDiv" style={{ borderTop: 'none' }}>

              </div>
              <div className="borderedDiv">
                <p className="w-25 fw-700">Item Name</p>
                <p className="w-25 justify-content-end">Rate</p>
                <p className="w-25 justify-content-center">Qty</p>
                <p className="w-25 justify-content-end">Amount</p>
              </div>

            </div>
            {invoiceOrderItems?.map((data, ind) => (
              <div className="borderedDiv other" key={ind}>
                <p className="w-25">{data?.name}</p>
                <p className="w-25 justify-content-end">
                  {data?.amountBeforeTax}
                </p>
                <p className="w-25 justify-content-center">{data?.qty}</p>
                <p className="w-25 justify-content-end">
                  {data?.qty * data?.amountBeforeTax}
                </p>
              </div>
            ))}

            <div className="borderedDiv flex-column p-1">
              <p className="justify-content-between w-100">
                Gross Amount: <span>{showRowPrice(selectedInvoiceData?.totalFoodAmountBeforeGST)}</span>
              </p>
              <p className="justify-content-between w-100">
                Discount ({selectedInvoiceData?.discountPercentage}%) Amount:
                <span>{Math.round(selectedInvoiceData?.totalFoodAmountBeforeGST * selectedInvoiceData?.discountPercentage / 100)}</span>
              </p>
              <p className="justify-content-between w-100">
                SGST:
                <span>
                  {
                    ((selectedInvoiceData?.totalFoodAmountBeforeGST - (selectedInvoiceData?.totalFoodAmountBeforeGST * selectedInvoiceData?.discountPercentage / 100)) * 2.5 / 100).toFixed(2)
                  }
                </span>
              </p>
              <p className="justify-content-between w-100">
                CGST:
                <span>
                  {
                    ((selectedInvoiceData?.totalFoodAmountBeforeGST - (selectedInvoiceData?.totalFoodAmountBeforeGST * selectedInvoiceData?.discountPercentage / 100)) * 2.5 / 100).toFixed(2)
                  }
                </span>
              </p>
              <p className="justify-content-between w-100">
                Total Amount:
                <span>{Math.round(newAmount)}</span>
              </p>

              <p className="justify-content-between w-100">
                Paid Amount:
                <span>{selectedInvoiceData?.paidAmount}</span>
              </p>
            </div>
            {/* <div className="borderedDiv flex-column align-items-start">
              <p>
                Customer Name:{" "}
                {booking?.User?.name}
              </p>
              <p>
                Customer GST:
                <input
                  type="text"
                  className="noCenter mw-100"
                  style={{ borderWidth: textInputs.gst.length > 0 ? 0 : 1 }}
                  value={textInputs.gst}
                  onChange={(e) =>
                    setTextInputs({ ...textInputs, gst: e.target.value })
                  }
                />
              </p>
            </div> */}
          </div>
        </div>
      </div>

      <div className="tab-primary buttons">
        <Tabs
          activeKey={activeTab}
          defaultActiveKey={ORDER_STATUS.UPCOMING}
          onSelect={(tabKey) => setActiveTab(tabKey)}
        >
          {propertyStatusTabs.map((tab, ind) => {
            return <Tab eventKey={tab.key} key={ind} title={tab.title} />;
          })}
        </Tabs>
      </div>

      <div className="table-responsive table-column-nowrap">
        <table className="dashboard-table" ref={tableRef}>
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Order ID</th>
              <th>Created By</th>
              <th>KOT Type</th>
              <th>Booking ID</th>
              <th>Guest</th>
              <th>Items</th>
              <th>Room No.</th>
              <th>Amount</th>
              <th>Order Date</th>
              {(activeTab == ORDER_STATUS.DELIVERED ||
                activeTab == ORDER_STATUS.COMPLETE ||
                activeTab == ORDER_STATUS.ALL) && (
                  <th>
                    {activeTab == ORDER_STATUS.COMPLETE
                      ? "Completed "
                      : "Delivered "}
                    Date
                  </th>
                )}

              <th>Order Status</th>
              {(activeTab < 3) && (
                <th style={{ minWidth: 200 }}>Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {filterOrders?.length > 0 ? (
              [...filterOrders]?.reverse()?.map((data, key) => {
                return (
                  <tr key={key}>
                    <td data-label="Sr. No.">
                      {key + 1}
                    </td>
                    <td data-label="Order ID">{data.id}</td>
                    <td data-label="Created By">
                      {data?.userId
                        ? "Guest"
                        : loginUsers.find((i) => i.id == data?.createdBy)
                          ?.firstName ?? "N/A"}
                    </td>
                    <td data-label="KOT Type">
                      {data?.ncType}
                    </td>
                    <td data-label="Booking ID">
                      {data.BookingHotel?.bookingCode ? (
                        <Link to={`/dashboard/all-bookings/${data?.bookingId}`}>
                          #{data?.BookingHotel?.bookingCode ?? "N/A"}
                        </Link>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td data-label="Guest" className="text-capitalize">
                      {data?.otherGuestName ?? "N/A"}
                    </td>
                    <td data-label="Items">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setSelectItemsShow(data);
                          setItemsModal(true);
                        }}
                      >
                        Show Items
                      </button>
                    </td>
                    <td data-label="Room No.">{data.roomNumber ? data.roomNumber : 'N/A'}</td>
                    <td data-label="Amount">
                     
                        <div className="text-primary">
                          ₹
                          {/* {data.orderAmount} */}
                          {
                            data?.discountPercentage == 0
                              ? data?.orderAmount
                              : (() => {
                                let frontAmount = data?.totalFoodAmountBeforeGST;
                                let frontDiscount = (frontAmount * data?.discountPercentage / 100);
                                let frontAfterDiscount = frontAmount - frontDiscount
                                let amountToShow = frontAfterDiscount + (frontAfterDiscount * 5) / 100;
                                return Math.round(amountToShow);
                              })()
                          }
                        </div>

                        <div className="d-flex">
                        {
                          // (data?.bookingId == 0 && data?.orderStatus == 3 && data.dueAmount > 0) && (
                          (data?.bookingId == 0 && data?.orderStatus == 3 && data.dueAmount > 0) && (
                            <button
                              class="btn btn-outline-primary btn-sm fs-10"
                              style={{ padding: '2px 4px' }}
                              onClick={() => handlePayments(data)}>
                              Collect
                            </button>
                          )
                        }

                        {
                          (data?.bookingId == 0 && data?.orderStatus == 3 && data?.paidAmount > 0) && (
                            <div>
                              <button
                                className="btn btn-sm"
                                onClick={() => {
                                  setShowPaymentPopup(true);
                                  setSelectedKot(data);
                                }}>
                                <FaReceipt />
                              </button>
                            </div>
                          )
                        }
                        </div>


                      
                    </td>
                    <td data-label="Order Date">
                      {
                        // moment(data.createdAt).format("DD-MM-YYYY, HH:mm A")
                        moment.utc(data?.createdAt).utcOffset("+05:30").format("DD-MM-YYYY, hh:mm A")
                      }
                    </td>
                    {(activeTab == ORDER_STATUS.DELIVERED ||
                      activeTab == ORDER_STATUS.COMPLETE ||
                      activeTab == ORDER_STATUS.ALL) && (
                        <td data-label="Date">
                          {
                            data?.deliveredAt ?
                              moment.utc(data?.deliveredAt).utcOffset("+05:30").format("DD-MM-YYYY, hh:mm A") : '-'
                          }
                        </td>
                      )}

                    <td data-label="Order Status">
                      <div className="right-sm">
                        <span
                          className="deliver fw-medium"
                          style={{ color: statusfoodColor[data.orderStatus] }}
                        >
                          {statusfood[data.orderStatus]}
                        </span>

                        {
                          (data.orderStatus == 3 && data?.bookingId == 0) && (
                            <>
                              <button type="button" className="btn btn-outline-primary btn-sm ml-2" disabled={data?.paymentStatus != 1} onClick={() => printPaymentSlip(data)}>Print Payment Slip</button>
                              <button type="button" className="btn btn-outline-primary btn-sm ml-2" disabled={data?.paymentStatus != 1} onClick={() => printInvoice(data)}>Print Food Invoice</button>
                            </>
                          )
                        }
                      </div>

                    </td>
                    {(activeTab < 3) && (
                      <td data-label="Action">
                        <div className="right-sm">
                          {userDetail?.Role?.canEdit == 1 && data?.orderStatus == 0 ? (
                            <Button
                              disabled={isLoading}
                              variant="secondary"
                              className="btn-sm mr-2"
                              onClick={!isLoading ? () => editHandler(data) : null}
                              title="Edit KOT"
                            >
                              <i
                                className="fa fa-pencil-square-o"
                                aria-hidden="true"
                              ></i>
                            </Button>
                          ) : null}

                          {data.orderStatus === 0 || data.orderStatus === 1 ? (
                            <Button
                              disabled={isLoading}
                              variant={`${data.orderStatus != 1 && 'primary' || data.orderStatus == 1 && 'success'}`}
                              className="btn-sm mr-2"
                              onClick={
                                !isLoading
                                  ? () =>
                                    changeStatus(
                                      data,
                                      statusfood[data.orderStatus]
                                    )
                                  : null
                              }
                            >
                              {data.orderStatus == 0 && 'Accept' || data.orderStatus == 1 && 'Mark Ready'}
                            </Button>
                          ) : null}

                          {
                            // [0, 1].includes(data.orderStatus) && ( // show Rejected button on new order and in kitchen both tabs
                            [0].includes(data.orderStatus) && (
                              <Button
                                disabled={isLoading}
                                variant="danger"
                                className="btn-sm"
                                onClick={
                                  !isLoading
                                    ? () => changeStatus(data, "Delivered")
                                    : null
                                }
                              >
                                Reject
                              </Button>
                            )
                          }

                          {
                            (data.orderStatus == 2 && activeTab == 2) && (
                              <Button
                                disabled={isLoading}
                                variant="success"
                                className="btn-sm"
                                onClick={
                                  !isLoading
                                    ? () => changeStatus(data, "Food is Ready")
                                    : null
                                }
                              >
                                Delivered
                              </Button>
                            )
                          }
                        </div>

                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={13} className="justify-content-center">
                  <span className="fw-bold">No KOT Found</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal
        show={showPaymentPopup}
        onHide={() => {
          setShowPaymentPopup(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-dark">Food Payments</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Order Amount</th>
                <th>Payment</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {foodPaymentHistory?.length > 0 ?
                foodPaymentHistory?.map((item) => {
                  return (
                    <tr>
                      <td>{item?.orderAmount}</td>
                      <td>{item?.paymentAmount}</td>
                      <td>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => deleteFoodPayment(item?.id)}>
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  )
                }) : <tr><td colSpan={3} style={{ textAlign: 'center', padding: '10px' }}>No Data Found</td></tr>
              }

            </tbody>
          </table>
        </Modal.Body>
      </Modal>


      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          setItemInput([{ itemName: "", qty: 1, price: "", amount: "" }]);
          reset();
          setEditMode(false);
          setBookingId({});
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-dark">{editMode ? "Edit " : "Create "}Food Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="p-4  p-xs-10"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row>
              <div className="flex m-0 p-0">
                <Col
                  lg={6} xs={12}>
                  <div className="field-group">
                    <label className="field-label">KOT Type</label>
                    {editMode ? (
                      <input
                        type="text"
                        className="field-control"
                        value={watch("kotType")}
                        readOnly
                      />
                    ) : (
                      <select
                        className="field-control form-select"
                        {...register('kotType', { required: 'KOT Type is required' })}
                      >
                        <option value="">Select KOT type</option>
                        {KOT_TYPE?.map((item) => (
                          <option key={item?.id} value={item?.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>)}
                    {errors.kotType && (
                      <span className="field-error">{errors.kotType.message}</span>
                    )}
                  </div>
                </Col>
                {(kotType == "Room Service" || kotType == "Complementary") && (
                  <Col lg={6} xs={12}>
                    <div className="field-group">
                      <label className="field-label">Room Number</label>
                      {editMode ? (
                        <input
                          type="text"
                          className="field-control"
                          value={kotSelectedRoom}
                          readOnly
                        />
                      ) : (
                        <select
                          className="field-control form-select"
                          {...register("selectRoom", { required: "Room selection is required" })}
                        >
                          <option value="">Select Room</option>
                          {roomNumbers?.map((item) => (
                            <option value={item?.assignRoomNo} key={item?.assignRoomNo}>
                              {item?.assignRoomNo} - {item?.source?.startsWith('OTA') ? item?.otaBookingId : item?.bookingCode} - {item?.otherPersonName ?? item?.User?.name ?? ''}
                            </option>
                          ))}
                        </select>
                      )}
                      {errors.selectRoom && (
                        <span className="field-error">{errors.selectRoom.message}</span>
                      )}
                    </div>
                  </Col>
                )}
              </div>
              <Col lg={6} xs={12}>
                <div className="field-group">
                  <label className="field-label">Waiter Name</label>
                  <select
                    className="field-control form-select"
                    {...register('waiterName', { required: 'Waiter is required' })}
                  >
                    <option value="">Select Waiter</option>
                    {
                      waiterList?.map((item) => (
                        <option value={item?.id}>{item?.firstName}</option>
                      ))
                    }
                  </select>
                  {errors.waiterName && (
                    <span className="field-error">{errors.waiterName.message}</span>
                  )}
                </div>
              </Col>
              <Col lg={6} xs={12}>
                <div className="field-group">
                  <label className="field-label">Remarks</label>
                  <input
                    type="text"
                    className="field-control"
                    placeholder="Enter Remark"
                    {...register('remarks', {
                      validate: (value) => {
                        if ((kotType !== "Room Service" && kotType !== "Dine-In") && !value) {
                          return 'Remark is required';
                        }
                        return true;
                      }
                    })}
                  />
                  {errors.remarks && (
                    <span className="field-error">{errors.remarks.message}</span>
                  )}
                </div>
              </Col>
              {itemInput?.map((item, ind) => {
                return (
                  <Col xs={12} key={ind}>
                    <div className="addItems d-flex mt-0">
                      {itemInput?.length > 1 && (
                        <div>
                          <div
                            className={`cutIcon`}
                            onClick={() => closeHandler(ind)}
                          >
                            <i className="fa fa-times" aria-hidden="true"></i>
                          </div>
                        </div>
                      )}
                      <Col xs={5} className="form-group full m-0">
                        <label>Item Name</label>
                        <Select
                          options={foodItems}
                          placeholder={"Select"}
                          value={item?.itemName}
                          onChange={(dataSet) => {
                            changeHandler(dataSet, ind, true);
                          }}
                          isSearchable={true}
                          getOptionLabel={(e) => `${e.itemCode} - ${e.name}`}
                        />
                        {item.itemName.length <= 0 && (
                          <div className="error-text">
                            <span>Please Select Item*</span>
                          </div>
                        )}
                      </Col>
                      <Col lg={3} className="form-group item m-0">
                        <label>Quantity</label>
                        <div className="d-flex justify-content-between incDec">
                          <button
                            className="incDecBtn"
                            type="button"
                            onClick={() => quatitySetup(item, false, ind)}
                          >
                            -
                          </button>
                          <input
                            className="text-center"
                            type="number"
                            name="qty"
                            placeholder="Enter Quantity"
                            value={item.qty}
                            disabled
                          />
                          <button
                            className="incDecBtn"
                            type="button"
                            onClick={() => quatitySetup(item, true, ind)}
                          >
                            +
                          </button>
                        </div>
                        {item.qty.length <= 0 && (
                          <div className="error-text">
                            <img alt="" src={AlertIcon} />
                            <span>Enter Quantity*</span>
                          </div>
                        )}
                      </Col>
                      <Col lg={2} className="form-group item m-0">
                        <label htmlFor="itemPrice">Item Price</label>
                        <input
                          id="itemPrice"
                          type="number"
                          name="price"
                          placeholder="Price"
                          onChange={(e) => changeHandler(e, ind)}
                          value={item.price}
                          disabled
                        />
                      </Col>
                      <Col xs={2} className="form-group item">
                        <label htmlFor="totalAmount">Total</label>
                        <input
                          id="totalAmount"
                          type="number"
                          name="amount"
                          placeholder="Amount"
                          value={item.amount}
                          disabled
                        />
                      </Col>
                    </div>
                  </Col>
                );
              })}
              <Col
                xs={12}
                className="form-group flex justify-content-between mt-2 align-center"
              >
                <Button
                  variant="outline-success"
                  type="button"
                  className="fs-12 btn-sm"
                  onClick={() =>
                    setItemInput([
                      ...itemInput,
                      { itemName: "", qty: 1, price: "", amount: "" },
                    ])
                  }
                >
                  + Add Item
                </Button>
                <h6 className="d-flex flex-column">
                  <span> Grand Total - ₹ {orderAmt}</span>
                </h6>
              </Col>
              <Col
                xs={12}
                className="form-group flex justify-content-end mt-4"
              >
                <Button
                  variant="primary"
                  type="submit"
                  disabled={submitDisabled}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={itemsModal} onHide={() => setItemsModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Order Items</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <Row id="pdf">
            <Row className="mb-2">
              <Col xs={6}>
                <span className="text-black">
                  Order Number: {selectItemsShow?.id}
                </span>
              </Col>

              {selectItemsShow?.bookingId != 0 &&
                <Col xs={6} className="text-end">
                  <span className="text-black">
                    Room Number: {selectItemsShow?.roomNumber}
                  </span>
                </Col>
              }
              {selectItemsShow?.bookingId != 0 &&
                <Col xs={6}>
                  <span className="text-black">
                    Booking ID: {selectItemsShow?.BookingHotel?.bookingCode}
                  </span>
                </Col>
              }
              <Col xs={6} className="text-end">
                <span className="text-black">
                  Guest Name:
                  {selectItemsShow.otherGuestName ?? "N/A"}
                </span>
              </Col>
            </Row>
            <Table striped hover className="modal_Table common-table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {
                  parsedData?.map((item, ind) => (
                    <tr key={ind}>
                      <td>{item.name}</td>
                      <td className="text-center">{showPrice(item.price)}</td>
                      <td className="text-center">{item.qty}</td>
                      <td className="text-center">
                        {showPrice(item.price * item.qty)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            {selectItemsShow?.ncType !== "0" && (
              <Col xs={6}>
                <span>Remark : {selectItemsShow?.remark}</span>
              </Col>
            )}
            {selectItemsShow.ncType == 1 && (
              <Col xs={6} className="d-flex justify-content-end">
                <span>Non Chargable KOT</span>
              </Col>
            )}
            <div className="flex justify-content-between">
              <span className="text-black text-end">
                Created By:{" "}
                {selectItemsShow.userId
                  ? "Guest"
                  : loginUsers.find((i) => i.id == selectItemsShow.createdBy)
                    ?.firstName +
                  " " +
                  loginUsers.find((i) => i.id == selectItemsShow.createdBy)
                    ?.lastName ?? "Guest"}
              </span>
              <span className="text-black text-end">
                Date & Time:{" "}
                {moment(selectItemsShow.createdAt).format(
                  "DD-MM-YYYY hh:mm A"
                )}
              </span>
            </div>
            <Row className="d-flex justify-content-end mt-2">
              <div md={8}>
                <span className="text-success text-end border border-success px-2 py-1 rounded-sm ">
                  Order Amount : {showPrice(selectItemsShow.orderAmount)}
                </span>
              </div>
            </Row>
          </Row>
          <Row className="d-flex justify-content-center pr-2">
            <Col xs={3} className="text-center">
              <select className="form-select field-control w-100 mb-4" onChange={(e) => setSelectedPrinter(e.target.value)} value={selectedPrinter}>
                <option value="">Select Printer</option>
                {printers?.map((printer, index) => (
                  <option key={index} value={printer}>{printer}</option>
                ))}
              </select>
              <Button variant="primary" className="btn-sm" onClick={printKot}>
                Print
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <PaymentModal
        paymentModal={paymentModal}
        setPaymentModal={setPaymentModal}
        orders={singleOrders}
        setSingleOrders={setSingleOrders}
        refreshKot={getDataHandlers}
      />

      <div
        className="print-box print-font"
        ref={kotPrint}
        style={
          {
            width: `${selectedPrinter == 'A4' ? '50%' : '80mm'}`,
            backgroundColor: '#fff', position: "fixed", bottom: '0px', right: '0px', zIndex: "-999",
            borderBottom: 'dashed 1px #000',
            padding: '20px',
          }
        }>
        <Row id="pdf" >
          <Col xs={12}>
            <table style={{ width: '100%', border: 'none', padding: '0px', margin: '0px' }}>
              <thead>
                <tr>
                  <th colSpan={2} className="text-center print-head">
                    <h1>{userDetail?.property?.name}</h1>
                  </th>
                </tr>
                <tr>
                  <th colSpan={2}>
                    <div style={{ height: '12px' }}></div>
                  </th>
                </tr>
                <tr>
                  <th style={{ border: 'none', padding: '0px' }}>
                    Order Number
                  </th>
                  <td style={{ border: 'none', padding: '0px', textAlign: 'right' }}>
                    {selectItemsShow?.id}
                  </td>
                </tr>
              </thead>
              <tbody>
                {selectItemsShow?.bookingId != 0 &&
                  <tr>
                    <th style={{ border: 'none', padding: '0px' }}>
                      Room Number
                    </th>
                    <td style={{ border: 'none', padding: '0px', textAlign: 'right' }}>
                      {selectItemsShow?.roomNumber}
                    </td>
                  </tr>
                }
                {selectItemsShow?.bookingId != 0 &&
                  <tr>
                    <th style={{ border: 'none', padding: '0px' }}>
                      Booking ID
                    </th>
                    <td style={{ border: 'none', padding: '0px', textAlign: 'right' }}>
                      {selectItemsShow?.BookingHotel?.bookingCode}
                    </td>
                  </tr>
                }
                <tr>
                  <th style={{ border: 'none', padding: '0px' }}>
                    Guest Name
                  </th>
                  <td style={{ border: 'none', padding: '0px', textAlign: 'right' }}>
                    {selectItemsShow.otherGuestName ?? "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{ width: '100%', height: '1px', backgroundColor: '#000', marginTop: '15px', marginBottom: '2px' }}></div>
            <Table hover className="modal_Table" style={{ border: 'none', padding: '0px', margin: '0px' }}>
              <thead>
                <tr>
                  <th style={{ border: 'none', padding: '0px' }}>Name</th>
                  <th style={{ border: 'none', padding: '0px', textAlign: 'right' }}>QTY</th>
                </tr>
              </thead>
              <tbody>
                {parsedData?.map((item, ind) => (
                  <tr key={ind}>
                    <td style={{ border: 'none', padding: '0px' }}>
                      <strong>{item.name}</strong>
                    </td>
                    <td style={{ border: 'none', padding: '0px', textAlign: 'right' }}>
                      <strong>{item.qty}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div style={{ width: '100%', height: '1px', backgroundColor: '#000', marginTop: '10px', marginBottom: '10px' }}></div>
            {selectItemsShow?.ncType !== "0" && (
              <div>
                <span>
                  Remark : {selectItemsShow?.remark}
                </span>
              </div>
            )}
            {selectItemsShow.ncType == 1 && (
              <Col xs={6} className="d-flex justify-content-end">
                <span style={{ fontSize: "16px" }}>Non Chargable KOT</span>
              </Col>
            )}
            <Table style={{ border: 'none', padding: '0px', margin: '0px' }}>
              <thead>
                <tr>
                  <th style={{ border: 'none', padding: '0px' }}>
                    Created By
                  </th>
                  <td style={{ border: 'none', padding: '0px', textAlign: 'right' }}>
                    {" "}
                    {selectItemsShow.userId
                      ? "Guest"
                      : loginUsers.find((i) => i.id == selectItemsShow.createdBy)
                        ?.firstName +
                      " " +
                      loginUsers.find((i) => i.id == selectItemsShow.createdBy)
                        ?.lastName ?? "Guest"}
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style={{ border: 'none', padding: '0px' }}>
                    Date & Time
                  </th>
                  <td style={{ border: 'none', padding: '0px', textAlign: 'right' }}>
                    {" "}
                    {moment(selectItemsShow.createdAt).format("DD-MM-YYYY, hh:mm A")}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col xs={4}></Col>
        </Row>
      </div>
    </Layout>
  );
};

export default FoodsOrders;
